import MultiSelectDropdown from '../../Controls/multiselectdropdown';
import '../../../assets/Styles/DispatchCSS/DispatchCSS.css';
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {Col, Container, Modal, Row, Button, Spinner }from 'react-bootstrap';
import APICom from '../../../utils/helpers/APICom';
import PenaltyForm from './PenaltyForm';
import AlertBox from '../../common/alert';
import Select from 'react-select';

const Penalize = (props) => {
    const {FamilyData, AffiliateData, DispatchDriverData} = useSelector((store) => store.combinedata);
    const [driverFilterMultiSelect, setDriverFilterMultiSelect] = useState({options: [], DropdownMode: 'rS', styles:{width:"98%", marginLeft:"0px"}});
    const [selectedDriver, setSelectedDriver] = useState("-1");
    const [FamilyGroupsSingleSelect, SetFamilyGroupsMultiSelect] = useState({options: [],selectedValues:[],placeholder:"Family Filter",displayValue:"name",emptyRecordMsg:"N/A",id:"DispatchGridFamilySelect",className:"DispatchGridFamilySelect",singleSelect:true, showCheckbox:false, TriggerSelectEventOnDataPopulate: false,styles:{width:"150px", marginLeft:"10px"}});
    const [AffiliatesFilterMultiSelect, SetAffiliatesFilterMultiSelect] = useState({options: [],selectedValues:[],placeholder:"Select Affiliates",displayValue:"name",emptyRecordMsg:"N/A",id:"DispatchGridAffiliatesSelect",className:"DispatchGridAffiliatesSelect" ,styles:{width:"160px", marginLeft:"10px"}});
    const [showPenaltyForm, setShowPenaltyForm] = useState(false);
    const [penRsn, setpenRsn] = useState("-1");
    const [penStrt, setpenStrt] = useState("-1");
    const [penTime, setpenTime] = useState("-1");
    const [penMile, setpenMile] = useState("-1");
    const [penHrs, setpenHrs] = useState("-1");
    const [penHrsLeft, setpenHrsLeft] = useState("-1");
    const [title, setTitle] = useState("-1");
    const [body, setBody] = useState("-1");
    const [showAlert, setShowAlert] = useState(false);

    const handleOk = () => {
        if (selectedDriver === '-1' || selectedDriver === '') {
            // No column selected, show the alert
            setTitle('Driver Missing');
            setBody('Driver cannot be null. please Select the Driver..');
            setShowAlert(true);
          } else {
            // A column is selected, hide the alert
            PenalizeDriver();
          }
    };

    const handleCancel = () => {
        props.setShowPenalty(false);
    };
    const handleCloseDriverPenaltyDialog = () => {
        if(props.showPenalty)
        {
            props.setShowPenalty(false);
        }
    }
    const dropdownpadding = {
        paddingLeft: '5px'
    };
    const PenalizeDriver = async () => {
        let dId = selectedDriver;
        let response = await APICom.fetchData("", "DispatchActions/GetDriverById?DriverId=" +dId, "get", { "Content-Type": "application/json" }, null, null);
        if(response.data.length > 0)
        {

            setpenRsn(response.data[0]["PenaltyReason"]);
            //setpenStrt(new Date(response.data[0]["dtPenStart"]).toLocaleDateString());
            setpenStrt(new Date(response.data[0]["dtPenStart"]).toISOString().split('T')[0]);

            setpenTime(new Date(response.data[0]["dtPenStart"]).toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute:'2-digit'}));
            setpenHrs(response.data[0]["dPenHour"]);
            setpenMile(response.data[0]["dPenMile"]);
            setpenHrsLeft(response.data[0]["HoursLeft"]);
            setShowPenaltyForm(true);


            //setIRTPUAlertObj({...irtpuAlertObj, alertTitle: 'IRTPU Action', alertMsg: "Action performed successfully."});
        }
        else
        {
            // setIRTPUAlertObj({...irtpuAlertObj, alertTitle: 'IRTPU Failed', alertMsg: "Action failed."});
            // setIRTPUAlert(true);
        }
      }

    const DriverSelectCallback = (_selectedDriverID) => {
        setSelectedDriver(_selectedDriverID);
    }
    useEffect(() => {
        let initialFamilyGroupSelected = [];
         let optsFamily = [];
    if (props.GridRowData.length === 0)
    {
        setTitle('Record Not Found');
            setBody('No request selected for Penalize!');

            setShowAlert(true);
    }
    else{
        for(var i = 0; i < FamilyData.length; i++){
          if(i===0){initialFamilyGroupSelected.push(FamilyData[i]["iATSPGroupID"].toString()); }
          optsFamily.push({"name":FamilyData[i]["vATSPGroupName"], "id":FamilyData[i]["iATSPGroupID"]})
        }
    
            SetFamilyGroupsMultiSelect({ ...FamilyGroupsSingleSelect, ...{options: optsFamily}});
            FilterAffiliatesBySelectedFamily(initialFamilyGroupSelected);
    
        if(props.GridRowData !== undefined)
        {
            
            if(DispatchDriverData !== undefined && DispatchDriverData !== null){
                let DriversOptions = [];
                let DispatchDriverByAffiliate = DispatchDriverData[props.GridRowData[0].iSRATSPID];
                if(DispatchDriverByAffiliate !== ""){
                    JSON.parse(DispatchDriverByAffiliate).map((item) => {
                        DriversOptions.push({"label":item.DriverName + ', '+item.DriverNumber , "value":item.DriverID})
                    });
                }
                
                if(DriversOptions.length > 0)
                {
                    setDriverFilterMultiSelect({...driverFilterMultiSelect, ...{options: DriversOptions}});
                }
            }
        }
    }
    },[]);


    function FilterAffiliatesBySelectedFamily(selectedvals){
        let optsAffiliates = [];
        let initialAffiliatesListSelected = [];
        for(var i = 0; i < AffiliateData.length; i++){
          if(selectedvals.indexOf(AffiliateData[i].DTSPID.toString()) > -1){
            initialAffiliatesListSelected.push(AffiliateData[i]["AffiliateID"].toString());
            optsAffiliates.push({"name":AffiliateData[i]["AffiliateCompany"], "id":AffiliateData[i]["AffiliateID"]});
          }
        }
        SetAffiliatesFilterMultiSelect({ ...AffiliatesFilterMultiSelect, ...{options: optsAffiliates}, selectedValues: optsAffiliates[0]});
        let DriversOptions = [];
        let DispatchDriverByAffiliate = DispatchDriverData[optsAffiliates[0]['id']];
        if(DispatchDriverByAffiliate !== ""){
            JSON.parse(DispatchDriverByAffiliate).map((item) => {
                DriversOptions.push({"label":item.DriverName + ', '+item.DriverNumber , "value":item.DriverID})
            });
        }
        setDriverFilterMultiSelect({...driverFilterMultiSelect, ...{options: DriversOptions}});

    }
    function FamilyGroupsSelectCallback(selectedfamily) {
        FilterAffiliatesBySelectedFamily(selectedfamily);
      }

      function FilterDriverBySelectedAffiliate(_selected_affiliate){
          let DriversOptions = [];
          let DispatchDriverByAffiliate = DispatchDriverData[_selected_affiliate];
          if(DispatchDriverByAffiliate !== ""){
              JSON.parse(DispatchDriverByAffiliate).map((item) => {
                  DriversOptions.push({"label":item.DriverName + ', '+item.DriverNumber , "value":item.DriverID})
              });
          }

          if(DriversOptions.length > 0)
          {
              setDriverFilterMultiSelect({...driverFilterMultiSelect, ...{options: DriversOptions}});
          }
      }

    return(
        <>
           <Modal show={props.showPenalty ? 1:0} centered onHide={handleCloseDriverPenaltyDialog} backdrop="static" keyboard={true} size="lg"
            aria-labelledby="contained-modal-title-vcenter" >
                <Modal.Header className='activate_dialog_header_bgcolor' closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" className='activate_dialog_title_color'>
                        Penalize Driver
                    </Modal.Title>
                </Modal.Header>
                    <Modal.Body className="grid-example">
                   
                        <Row className="tripaction_btn_seperator"></Row>
                        <Row>
                            <Col xs={6} md={6}>
                            Affiliate Group:<MultiSelectDropdown options={FamilyGroupsSingleSelect} singleselect="true" style={dropdownpadding} SelectionChangeCallback={FamilyGroupsSelectCallback} />
                            </Col>
                            <Col xs={6} md={6}>
                            Affiliates:<MultiSelectDropdown options={AffiliatesFilterMultiSelect} singleselect="true" style={dropdownpadding} SelectionChangeCallback={FilterDriverBySelectedAffiliate} />
                            </Col>
                        </Row>
                        <Row className="tripaction_btn_seperator"></Row>
                        <Col xs={6} md={6}>
                        Please Select Driver# To Set Penalty For...
                            <Select
                                value={selectedDriver.selectedDriver}
                                onChange={(selectedOption) => DriverSelectCallback(selectedOption.value)}
                                options={driverFilterMultiSelect.options}
                            />

                        </Col>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleOk}>
                            OK
                        </Button>
                        <Button variant="secondary" onClick={handleCancel}>
                            Cancel
                        </Button>
                    </Modal.Footer>
            </Modal>
            {showPenaltyForm ? <PenaltyForm showPenaltyForm={showPenaltyForm}  setShowPenaltyForm={setShowPenaltyForm} penRsn={penRsn} penStrt={penStrt} penTime={penTime} penMile={penMile} penHrs={penHrs} penHrsLeft={penHrsLeft} driverId={selectedDriver}/>:"" }
            {showAlert ? <AlertBox showAlert={showAlert} setShowAlert={setShowAlert} title={title} body={body} />: ""}
            {/*{showAlert && <div className="alert">Please select a column.</div>} */}
            {/*{irtpuComponentLoaded ? <IRTPU GridRowData={props.GridRowData} irtpuComponentLoaded={irtpuComponentLoaded} setIRTPUComponentLoad={setIRTPUComponentLoad} setIsProcessing={setIsProcessing}  /> : "" }*/}
        </>

    );
}

export default Penalize;